import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const UploadIcon = ({
  color = 'white',
  width = 10,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9976 1C11.3392 1 11.6788 1.11778 11.9486 1.35701L17.5357 6.29996C17.9678 6.68274 18.1169 7.28635 17.9037 7.82002C17.6942 8.35186 17.1697 8.70151 16.5847 8.70151H13.3562L13.3562 13.6997C13.3562 14.9695 12.3015 16 10.9976 16C9.69566 16 8.639 14.9695 8.639 13.6997L8.639 8.70151L5.4124 8.70151C4.82934 8.70151 4.3029 8.35186 4.09345 7.82002C3.88212 7.28634 4.0293 6.68458 4.4614 6.29996L10.0466 1.35701C10.3165 1.11778 10.6561 1 10.9976 1ZM3.5 18C2.67157 18 2 18.6716 2 19.5C2 20.3285 2.67157 21 3.5 21H18.5C19.3284 21 20 20.3285 20 19.5C20 18.6716 19.3284 18 18.5 18H3.5Z"
        fill={getSemanticTextColor(color)}
      />
    </svg>
  </DefaultIconWrapper>
);
